import { BackgroundModel } from 'src/app/engine/models/background.model';

export class SnapshotOptions {
  constructor(
    public dimensions = { width: 700, height: 550 },
    public imageType = 'image/jpeg',
    public labelScale = 1.0,
  ) {}
}
